module.exports = __webpack_public_path__ + "static/media/management_charmaine_brimm.8d7d7ba0.jpg";